import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Image = ({ image, alt, imgStyle, objectPosition, ...other }) => {
  if (image) {
    if (image.node?.publicURL && !image.node?.gatsbyImageData) {
      return <img src={image.node.publicURL} style={{ objectPosition }} alt={alt} {...other} />;
    }
    if (image.node?.gatsbyImageData) {
      return (
        <GatsbyImage
          image={getImage(image.node)}
          objectPosition={objectPosition}
          alt={alt}
          imgStyle={imgStyle}
          {...other}
        />
      );
    } else {
      return (
        <GatsbyImage
          image={image}
          objectPosition={objectPosition}
          alt={alt}
          imgStyle={imgStyle}
          {...other}
        />
      );
    }
  }
};

export default Image;
